import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import { calculateAge } from './utils/ageCalculator'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const AgeCalculator = () => {
  useDocumentMeta({
    title: 'Calculadora de Idade Online  jarder.dev',
    description:
      'Calcule sua idade exata em anos, meses e dias, e veja quantos ' +
      'dias faltam para o próximo aniversário. Grátis.',
  })

  const [birthDate, setBirthDate] = useState('')

  const age = useMemo(
    () => (birthDate ? calculateAge(birthDate) : null),
    [birthDate],
  )

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Calculadora de Idade</h1>
      <p className="tool-disclaimer">
        Descubra sua idade exata em anos, meses e dias.
      </p>

      <div className="tool-field">
        <label htmlFor="birth-date">Data de nascimento</label>
        <input
          id="birth-date"
          type="date"
          value={birthDate}
          onChange={(e) => {
            setBirthDate(e.target.value)
            trackEvent('tool_generate', { tool: 'age_calculator' })
          }}
        />
      </div>

      {age && (
        <div className="tool-result-card">
          <span className="tool-result-label">Sua idade</span>
          <span className="tool-result-value">
            {age.years} anos, {age.months} meses e {age.days} dias
          </span>
          <span className="tool-copied">
            {age.totalDays.toLocaleString('pt-BR')} dias vividos  faltam{' '}
            {age.daysToNextBirthday} dias para o próximo aniversário
          </span>
        </div>
      )}
      {birthDate && !age && (
        <p className="tool-error">Data inválida ou no futuro.</p>
      )}

      <div className="tool-info-section">
        <h2>Como a idade é calculada</h2>
        <p>
          A calculadora conta a diferença exata entre a data de nascimento
          e a data de hoje, ajustando meses e dias como um calendário real
          faria (considerando que fevereiro tem 28 ou 29 dias, meses com
          30 ou 31 dias etc.), em vez de simplesmente dividir o total de
          dias por 365.
        </p>
        <p>
          Também é mostrado o total de dias vividos e quantos dias faltam
          para o seu próximo aniversário  útil para saber, por exemplo,
          se você já pode tirar carteira de motorista, se atingiu a idade
          mínima para algum concurso ou simplesmente para planejar a
          festa.
        </p>
      </div>
    </div>
  )
}

export default AgeCalculator
